import { render, staticRenderFns } from "./prices-manager.vue?vue&type=template&id=0b87be99&"
import script from "./prices-manager.vue?vue&type=script&lang=js&"
export * from "./prices-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports